import { useEffect, useState } from 'react';

import 'antd/dist/antd.min.css';
import './assets/styles/App.scss';

// Helpers;
import store from 'store';
import history from './utils/history';
import { config } from './utils/config';
import { TagEvents, TagManager } from './utils/GTM';
import { postUserTracking } from './slices/userSlice';
import { useAppDispatch } from './app/hooks';
import RefreshOnVersionChange from './utils/RefreshOnVersionChange';

// Components
import Router from './components/Routes';
import BaseLayout from './components/Layout/BaseLayout';

const App = () => {
    const isAdult = store.get(config.user.isAdult);
    const dispatch = useAppDispatch();

    useEffect(() => {
        history.listen(() => {
            TagManager.dataLayer(TagEvents.pageView);
        });
    }, []);

    useEffect(() => {
        dispatch(postUserTracking({}));
    }, [dispatch]);

    useEffect(() => {
        if (isAdult) {
            TagManager.dataLayer(TagEvents.pageView);
            TagManager.initialize(TagEvents.init);
        }
    }, [isAdult]);

    return (
        <BaseLayout>
            <RefreshOnVersionChange />
            <Router />
        </BaseLayout>
    );
};

export default App;
